import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${pxToRem(24)};
  background: rgba(0, 0, 0, 0.5);
`;

export const ModalPanel = styled.div`
  width: min(${pxToRem(620)}, calc(100vw - ${pxToRem(48)}));
  max-height: calc(100vh - ${pxToRem(48)});
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${pxToRem(16)};
  box-shadow: ${({ theme }) => theme.shadows.lg};
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${pxToRem(16)};
  padding: ${pxToRem(20)} ${pxToRem(24)};

  h2 {
    margin: 0;
    color: ${({ theme }) => theme.colors.ink};
    font-size: ${pxToRem(24)};
    font-weight: 700;
  }
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(32)};
  height: ${pxToRem(32)};
  padding: 0;
  border: 0;
  border-radius: ${pxToRem(8)};
  background: transparent;
  color: ${({ theme }) => theme.colors.inkMuted};
  cursor: pointer;

  svg {
    width: ${pxToRem(18)};
    height: ${pxToRem(18)};
  }

  &:hover {
    background: ${({ theme }) => theme.colors.brandSubtle};
    color: ${({ theme }) => theme.colors.ink};
  }
`;

export const Divider = styled.div`
  height: ${pxToRem(1)};
  background: ${({ theme }) => theme.colors.inkBorder};
`;

export const ModalBody = styled.div`
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: ${pxToRem(24)};
`;

export const Toolbar = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${pxToRem(8)};
  margin-bottom: ${pxToRem(12)};
`;

export const ToolbarButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(34)};
  height: ${pxToRem(34)};
  padding: 0;
  border: 0;
  border-radius: ${pxToRem(8)};
  background: transparent;
  color: ${({ theme }) => theme.colors.inkMuted};
  cursor: pointer;

  svg {
    width: ${pxToRem(18)};
    height: ${pxToRem(18)};
  }

  &:hover {
    background: ${({ theme }) => theme.colors.brandSubtle};
    color: ${({ theme }) => theme.colors.brand};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;

export const NoteTextArea = styled.textarea`
  width: 100%;
  min-height: ${pxToRem(220)};
  max-height: 50vh;
  padding: ${pxToRem(16)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.inkBorder};
  border-radius: ${pxToRem(12)};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${pxToRem(16)};
  line-height: 1.5;
  resize: vertical;
  outline: none;

  &::placeholder {
    color: ${({ theme }) => theme.colors.inkMuted};
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.brand};
    box-shadow: 0 0 0 ${pxToRem(3)} ${({ theme }) => theme.colors.brandSubtle};
  }
`;

export const ModalFooter = styled.div`
  padding: 0 ${pxToRem(24)} ${pxToRem(24)};
`;
